/**
 * The label of a planning role for the block pill (spec §8.6 item 6). Online it is the ontology's
 * own label, cached by TanStack Query; offline the IRI's local name, which is what the role classes
 * are named after anyway (`ibis:Position` → "Position").
 */
import { useQuery } from "@tanstack/react-query";
import { api, unwrap } from "../api/client";
import { localName } from "../graph/nodeInfo";

interface TermDetail {
  iri: string;
  label: string;
}

export function useRoleLabel(iri: string): string {
  const term = useQuery({
    queryKey: ["term", iri],
    enabled: !!iri,
    staleTime: 24 * 60 * 60 * 1000,
    retry: false,
    queryFn: async () => unwrap<TermDetail>(await api.GET("/api/ontology/terms/{term_iri}", { params: { path: { term_iri: iri } } })),
  });
  return term.data?.label || localName(iri);
}

/** [M31] The same lookup for any ontology term, such as the class a fact is about. */
export const useTermLabel = useRoleLabel;
